import ExcelJS from "exceljs";
import { useDrainSlitComplaintReportStore } from "./useDrainSlitComplaintReportStore";

const HEADERS = [
  "S.No",
  "Complaint No",
  "Complainant Contact No",
  "Complainant Name",
  "Ward",
  "Colony Name",
  "Description",
  "Latitude, Longitude",
  "Complaint Created At",
  "Complaint Resolved At",
  "Status",
  "Time (Duration)",
  "Close Time Lat/Lon",
  "Action Remarks",
  "Resolved Ward",
  "Resolved Colony",
  "Resolved Location Latitude/Longitude",
  "Closed By",
];

const mapRow = (row, index) => [
  index + 1,
  row.complaintNo || "N/A",
  row.contactNo || "N/A",
  row.complainantName || "N/A",
  row.wardName || "N/A",
  row.colonyName || "N/A",
  row.description || "N/A",
  row.latitude != null && row.longitude != null
    ? `${row.latitude}, ${row.longitude}`
    : "N/A",
  row.complaintDate || "N/A",
  row.closedDate || "N/A",
  row.status || "N/A",
  row.actualDuration || "N/A",
  row.closeLatitude != null && row.closeLongitude != null
    ? `${row.closeLatitude}, ${row.closeLongitude}`
    : "N/A",
  row.actionRemarks || "N/A",
  row.revisedWardName || "N/A",
  row.revisedColonyName || "N/A",
  row.revisedLatitude != null && row.revisedLongitude != null
    ? `${row.revisedLatitude}, ${row.revisedLongitude}`
    : "N/A",
  row.closedBy || "N/A",
];

export const useDrainSlitComplaintExcelExport = () => {
  const { drainSlitComplaintOuterReport, filters } =
    useDrainSlitComplaintReportStore();

  const downloadExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const dateRange =
      filters?.FromDate && filters?.ToDate
        ? `(${filters.FromDate} to ${filters.ToDate})`
        : "";
    const reportTitle = `Drain Slit Complaints Report ${dateRange}`;
    const generatedText = `Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Drain Slit Complaints");
    const boldFont = { bold: true };
    const centerAlignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
    };

    const headerRow1 = worksheet.addRow([generatedText]);
    worksheet.mergeCells(headerRow1.number, 1, headerRow1.number, HEADERS.length);
    headerRow1.getCell(1).font = boldFont;
    headerRow1.getCell(1).alignment = centerAlignment;

    const headerRow2 = worksheet.addRow([reportTitle]);
    worksheet.mergeCells(headerRow2.number, 1, headerRow2.number, HEADERS.length);
    headerRow2.getCell(1).font = boldFont;
    headerRow2.getCell(1).alignment = centerAlignment;

    const tableHeaderRow = worksheet.addRow(HEADERS);
    tableHeaderRow.eachCell((cell) => {
      cell.font = { ...boldFont, color: { argb: "FFFFFFFF" } };
      cell.alignment = centerAlignment;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF004554" },
      };
    });

    (drainSlitComplaintOuterReport || []).forEach((item, index) => {
      const row = worksheet.addRow(mapRow(item, index));
      row.eachCell((cell) => {
        cell.alignment = centerAlignment;
      });
    });

    worksheet.columns = HEADERS.map(() => ({ width: 20 }));
    worksheet.getColumn(1).width = 8;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "DrainSlitComplaintsReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return downloadExcel;
};

const ExportDrainSlitComplaintExcel = () => {
  const downloadExcel = useDrainSlitComplaintExcelExport();

  return (
    <button type="button" className="btn btn-excel" onClick={downloadExcel}>
      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
    </button>
  );
};

export default ExportDrainSlitComplaintExcel;
